import { ofType } from 'redux-observable';
import { mergeMap, map, filter } from 'rxjs';
import { AppEpic } from 'src/store';
import { of } from 'rxjs';
import { inputIsNotNullOrUndefined, isScopeDefined, isSubheaderLoaded, topMemInWorklistSelected } from 'src/utils/Functions/epicsFunctions';
import {
  ConfDefnComponentType,
  isSameComponentType,
  ListAndNestedViewCombineComponent,
  maybeGetComponentProps,
} from 'src/services/configuration/codecs/confdefnComponents';
import { cleanUp, fetchListViewData, receiveConfig } from './ListView.slice';
import { isNil } from 'lodash';
import { ExtraPivotOptions, getAggBys, organizeListDataOptions } from '../../StyleColorReview/StyleColorReview.slice';
import { isListDataApi } from 'src/services/configuration/codecs/confdefnView';
import { updateFlowStatus } from 'src/components/Subheader/Subheader.slice';
import {
  receiveScopeConfig,
  receiveScopeRefreshTrigger,
} from 'src/components/AssortmentScopeSelector/AssortmentScopeSelector.slice';
import { receiveFilterStateAfterSubmission } from 'src/components/FilterPanel/FilterPanel.slice';
import { updateSelectedItem } from 'src/pages/Worklist/Worklist.slice';
import { setActivePage, setActiveSubPage } from 'src/pages/NavigationShell/NavigationShell.slice';

export const listViewLoad: AppEpic = (action$, state$) => {
  return action$.pipe(
    ofType(
      receiveScopeRefreshTrigger.type,
      receiveFilterStateAfterSubmission.type,
      setActivePage.type,
      setActiveSubPage.type,
      updateSelectedItem.type,
      updateFlowStatus.type,
      receiveConfig.type,
      receiveScopeConfig.type
    ),
    map(() => maybeGetComponentProps<ListAndNestedViewCombineComponent>(state$.value, ConfDefnComponentType.listView)),
    filter(inputIsNotNullOrUndefined),
    filter(() => topMemInWorklistSelected(state$.value)),
    filter(() => isScopeDefined(state$.value.scope) && isSubheaderLoaded(state$.value.subheader)),
    mergeMap(({ defns, topMembers }) => {
      const { dataApi, model: modelDefn } = defns;
      const finalModelDefn = isListDataApi(dataApi) ? dataApi.defnId : modelDefn;

      const flowStatus = state$.value.subheader.flowStatus.join(',');
      const aggBy = getAggBys(state$.value.subheader, dataApi, { forceReload: true });
      const options: ExtraPivotOptions = !isNil(topMembers) ? { topMembers, flowStatus, aggBy } : { flowStatus, aggBy };
      const finalOptions = organizeListDataOptions(options, dataApi);

      if (isSameComponentType<ListAndNestedViewCombineComponent>(state$.value, ConfDefnComponentType.listView)) {
        return of(cleanUp(), fetchListViewData(finalModelDefn, finalOptions));
      }

      return of(fetchListViewData(finalModelDefn, finalOptions));
    })
  );
};
